import { createContext, useContext } from 'react';

export interface Path {
  pathname: string;
  search: string;
  hash: string;
}
export type To = string | Partial<Path>;

export interface Location<State = unknown> extends Path {
  state: State;
  key?: string;
}
type LocationContextValue = Location | null;

export const LocationContext = createContext<LocationContextValue | undefined>(undefined);

export type NavigationContextValue = (to: To, opts?: {
  replace?: boolean;
}) => void;

export const NavigationContext = createContext<NavigationContextValue | undefined>(undefined);

type ChatRoutingProviderProps = {
  children: React.ReactNode;
  location: LocationContextValue;
  navigate: NavigationContextValue;
};

export const ChatRoutingProvider: React.FC<ChatRoutingProviderProps> = ({ children, location, navigate }) => {

  return (
    <LocationContext.Provider value={location}>
      <NavigationContext.Provider value={navigate}>
        {children}
      </NavigationContext.Provider>
    </LocationContext.Provider>
  );
};

export const useLocation = () => {
  const location = useContext(LocationContext);

  if (!location) {
    throw new Error('useLocation must be used within a ChatRoutingProvider');
  }
  return location;
};
export const useNavigate = () => {
  const navigate = useContext(NavigationContext);
  if (!navigate) {
    throw new Error('useNavigate must be used within a ChatRoutingProvider');
  }
  return navigate;
};